export default {
  pt:{
    nomeunidade: "Gabinete de Controlo da Qualidade (GCQ)",
    menu:{
      apresentacao: "Apresentação",
      documentacao: "Documentação e Legislação",
      inqueritos: "Inquéritos de Qualidade",
      acred: "Avaliação/Acreditação",
      faq: "Perguntas Frequentes"
    },
    apresentacao:{
      horario: "Horário de Expediente",
      horariosecontactos: "Horário e Contactos",
      email: "Email",
      telefone: "Telefone",
      morada: "Morada",
      conhercerequipa: "Conhecer Equipa",
      responsavel: "Responsável"
    },
    documentacao:{
      pesquisa: "Pesquisar Documentos"
    },
    pesquisa:{
      artigos: "Pesquisar Artigos",
      discursos: "Pesquisar Discursos",
      notas: "Pesquisar Notas"
    },
    vermais: "Ver Mais",
    apesquisar: "A pesquisar",
    forms:{
      pesquisaforms: "Pesquisar Formulários"
    },
    list:{
      ano: "Ano",
      designacao: "Designação",
      documentos: "Documentos"
    },
    breadcrumb:{
      homepage: "Homepage",
      sobre: "Sobre",
      admin: "Serviços Administrativos",
      sigla: "GCQ",
    },
    semdocumentos: "Sem documentos para apresentar",
    semformularios: "Sem Formulários para apresentar",
  },
  en: {
    nomeunidade: "Quality Assurance Office",
    menu:{
      apresentacao: "Apresentação",
      documentacao: "Documentação e Legislação",
      inqueritos: "Inquéritos de Qualidade",
      acred: "Avaliação/Acreditação",
      faq: "Perguntas Frequentes"
    },
    apresentacao:{
      horario: "Office Hours",
      horariosecontactos: "SCHEDULE AND CONTACTS",
      email: "Email",
      telefone: "Telephone",
      morada: "Address",
      conhercerequipa: "Meet the team",
    },
    documentacao:{
      pesquisa: "Search for Documents"
    },
    pesquisa:{
      artigos: "Pesquisar Artigos",
      discursos: "Pesquisar Discursos",
      notas: "Pesquisar Notas"
    },
    list:{
      ano: "Year",
      designacao: "Designation",
      documentos: "Documents"
    },
    breadcrumb:{
      homepage: "Homepage",
      sobre: "About",
      admin: "Administrative Services",
      sigla: "QAO",
    },
    apesquisar: "Searching",
    semdocumentos: "No documents to be shown",
    semformularios: "Sem Formulários para apresentar",
  }
}